import { approveFlowIfConfigured } from '../webservices/flowApprovalWS';
import { toast } from 'react-toastify';
import { SAVE_IN_PROGRESS, SAVE_PROCESS_DONE } from './fetchingDataActions';
import { fetchItemsWS } from '../webservices/fetchWS';
import { QuestionaireDTO } from './DTOs/QuestionaireDTO';
import { updateItemWs } from '../webservices/saveWS';

export const FETCHING_QUESTIONAIRES_ACTION = 'FETCHING_QUESTIONAIRES_ACTION';
export const FETCH_QUESTIONAIRES_SUCCESS_ACTION = 'FETCH_QUESTIONAIRES_SUCCESS_ACTION';
export const FETCH_QUESTIONAIRES_ERROR_ACTION = 'FETCH_QUESTIONAIRES_ERROR_ACTION';

export const fetchAllQnairesAction = (tenantId) => {
  const queryParams = {
    GSI3PK: `QNAIRES`,
    GSI3SK: 'QNAIRE#',
  };

  return async (dispatch, getState) => {
    dispatch({ type: FETCHING_QUESTIONAIRES_ACTION, payload: tenantId });

    try {
      const result = await fetchItemsWS('get-dynamodb', queryParams, getState);
      const returnItems = result.Items.filter((item) => item.status === 'underReview');
      dispatch({ type: FETCH_QUESTIONAIRES_SUCCESS_ACTION, payload: returnItems });
    } catch (err) {
      console.log(err);
      dispatch({ type: FETCH_QUESTIONAIRES_ERROR_ACTION, err });
    }
  };
};

export const FETCHING_REVIEW_QNAIRES_ACTION = 'FETCHING_REVIEW_QNAIRES_ACTION';
export const FETCH_REVIEW_QNAIRES_SUCCESS_ACTION = 'FETCH_REVIEW_QNAIRES_SUCCESS_ACTION';
export const FETCH_REVIEW_QNAIRES_ERROR_ACTION = 'FETCH_REVIEW_QNAIRES_ERROR_ACTION';

export const fetchTenantReviewQnaires = (tenant) => {
  const queryParams = {
    GSI2PK: `${tenant.id}%23QNAIRES`,
    GSI2SK: 'QNAIRE%23',
  };

  return (dispatch, getState) => {
    dispatch({ type: FETCHING_REVIEW_QNAIRES_ACTION });
    fetchItemsWS('get-dynamodb', queryParams, getState)
      .then((result) => {
        const returnItems = result.Items.filter((item) => item.status === 'underReview');
        dispatch({ type: FETCH_REVIEW_QNAIRES_SUCCESS_ACTION, payload: returnItems });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: FETCH_REVIEW_QNAIRES_ERROR_ACTION, err });
      });
  };
};

export const reviewQuestionaireAction = (questionnaire, actionType, tenant) => {
  return async (dispatch, getState) => {
    dispatch({ type: SAVE_IN_PROGRESS });
    try {
      if (actionType === 'validate' && (await approveFlowIfConfigured(questionnaire, getState))) {
        toast.info(
          'Flow approval queued. Check the questionnaire Flow status for publication and activation.',
        );
      } else {
        const isActive = actionType === 'validate';
        const saveObject = new QuestionaireDTO({
          ...questionnaire,
          status: isActive ? 'active' : 'denied',
          isActive,
          alwaysAnonymise: isActive && questionnaire.anonymisedData === true,
        });
        await updateItemWs(saveObject, getState);
        if (isActive) toast.success('The questionnaire has been successfully validated');
        else toast.warning('The questionnaire has been successfully denied');
      }
      dispatch(fetchTenantReviewQnaires(tenant));
      dispatch(fetchAllQnairesAction());
    } catch (error) {
      const code = error.response?.data?.error;
      const messages = {
        publication_not_enabled: 'Flow publication is not enabled yet. The questionnaire remains inactive.',
        generate_validated_draft_before_approval: 'Generate and validate the draft Flow before approving.',
        questionnaire_not_under_review: 'Request approval for the saved questionnaire first.',
        publication_queue_uncertain: 'Approval may have started. Refresh Flow status before retrying.',
      };
      toast.error(
        messages[code] || 'Approval could not complete. Refresh the questionnaire and check its Flow status.',
      );
    } finally {
      dispatch({ type: SAVE_PROCESS_DONE });
    }
  };
};
